import { ResourceVisibility } from './ResourceVisibility';

export const isVideoVod = (video) => video?.visibility !== ResourceVisibility.JUST_ME;
